
import AdminLayout from "@/components/admin/AdminLayout";
import MLInsightsDashboard from "@/components/admin/analytics/MLInsightsDashboard";
import { Brain } from "lucide-react";

const AdminMLAnalytics = () => {
  return (
    <AdminLayout>
      <div className="space-y-6">
        <div className="flex items-center space-x-3">
          <Brain className="h-8 w-8 text-purple-600" />
          <div>
            <h1 className="text-3xl font-bold text-foreground">Machine Learning Analytics</h1>
            <p className="text-muted-foreground mt-1">
              AI-powered insights, predictions, and business intelligence
            </p>
          </div>
        </div>

        <MLInsightsDashboard />
      </div>
    </AdminLayout>
  );
};

export default AdminMLAnalytics;
